import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  useApi,
  type GetEntityTitles200Response,
  type EntityTitlesFilteringDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type ListTitlesQueryParameters = {
  filter?: EntityTitlesFilteringDtoOptions;
  isActionTitle?: boolean;
  page?: number;
  limit?: number;
};

export type UseInfiniteTitlesParams = {
  enabled?: boolean;
} & ListTitlesQueryParameters;

export function useInfiniteTitles(props: UseInfiniteTitlesParams) {
  const { page = 0, limit = 10, filter = {}, enabled = true } = props;

  const api = useApi();

  const queryKey = ['entity-title', filter, page, limit, enabled];

  return useInfiniteQuery<
    GetEntityTitles200Response,
    ExtendedAxiosError,
    InfiniteData<GetEntityTitles200Response>,
    typeof queryKey,
    number
  >({
    queryKey: ['entity-titles', filter, page, limit, enabled],
    queryFn: ({ pageParam }) =>
      api.entityTitlesApi
        .getEntityTitles(filter, pageParam, limit)
        .then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
  });
}
